import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import {configureChains, mainnet, WagmiConfig, createClient} from 'wagmi';
import {publicProvider} from 'wagmi/providers/public';
const {provider, webSocketProvider} = configureChains(
  [mainnet],
  [publicProvider()] 
);

const client = createClient({
  autoConnect: true,
  provider,
  webSocketProvider
})

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <WagmiConfig client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </WagmiConfig>
);
